import { NetworkCrypto, SymbolCrypto } from "./api/generated"

export interface Pricing {
  address?: string
  amount?: string
  amount_paid?: string
  amount_rest?: null | string
  network?: NetworkCrypto
  rate?: null | string
  symbol?: SymbolCrypto
}

export const parsePricing = (pricing: Pricing) => {
  const cryptoAssets = Object.values(pricing)

  return cryptoAssets.find((item) => item?.amount_paid !== "0")
}
